import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import Tooltip from "@mui/material/Tooltip";
import "./Modal.css";
import LoadingSpinner from "./LoadingSpinner";
import ImageComponent from "../Components/ImageComponent";
import VideoComponent from "../Components/VideoComponent";

const apiUrl = process.env.REACT_APP_FILE_SERVER_URL;

function ModalMedia({ mediaURL, open, source, type, onClose }) {
  const renderMedia = () => {
    // if (source === "WABA") {
      if (mediaURL.includes(".mp4") || mediaURL.includes(".3gp")) {
        return (
          <video autoPlay controls>
            <source src={`${apiUrl}${mediaURL}`} />
          </video>
        );
      } else {
        return (
          <img alt="" src={`${apiUrl}${mediaURL}`} style={{ height: "90vh" }} />
        );
      }
    /* } else {
      // Facebook or Instagram media
      return (
        <>
          <ImageComponent src={mediaURL} />
          <VideoComponent src={mediaURL} />
        </>
      );
    } */
  };

  if (!open) return null;

  return (
    <div className="overlayMedia">
      <TransformWrapper>
        {({ zoomIn, zoomOut, ...rest }) => (
          <>
            <div className="media-buttons">
              <Tooltip title="Zoom In" arrow>
                <ZoomInIcon
                  // className="DownloadBtnMedia"
                  sx={{ cursor: "pointer", fontSize: 36 }}
                  onClick={() => zoomIn()}
                />
              </Tooltip>

              <Tooltip title="Zoom Out" arrow>
                <ZoomOutIcon
                  // className="DownloadBtnMedia"
                  sx={{ cursor: "pointer", fontSize: 36 }}
                  onClick={() => zoomOut()}
                />
              </Tooltip>

              <a
                href={source === "WABA" ? `${apiUrl}${mediaURL}` : mediaURL}
                rel="noopener noreferrer"
                style={{ display: "flex" }}
                target="_blank"
              >
                <Tooltip title="Save" arrow>
                  <DownloadIcon
                    // className="DownloadBtnMedia"
                    sx={{ color: "#fff", cursor: "pointer", fontSize: 36 }}
                  />
                </Tooltip>
              </a>

              <Tooltip title="Close" arrow>
                <CloseOutlinedIcon
                  // className="closeBtnMedia"
                  sx={{ cursor: "pointer", fontSize: 36 }}
                  onClick={onClose}
                />
              </Tooltip>
            </div>

            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="modalContainerMedia"
            >
              {!mediaURL ? <LoadingSpinner /> : ""}

              <div className="modalMedia">
                <TransformComponent>{renderMedia()}</TransformComponent>
              </div>
            </div>
          </>
        )}
      </TransformWrapper>
    </div>
  );
}

export default ModalMedia;
